<template>
  <p>{{ body }}</p>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'modal'
    }
  },

  computed: {
    body () {
      return this.$store.getters[`${this.modelName}/getAttr`]('body')
    }
  }
}
</script>
